import { Pipe, PipeTransform } from '@angular/core';
import moment, { Moment } from 'moment-timezone';

@Pipe({
  name: 'timezoneDate'
})
export class TimezoneDatePipe implements PipeTransform {
  transform(date: string, time: string, timezone: string): string {
    if (!date) {
      return;
    }

    const dateTime = `${date} ${time || '00:00'}`;
    if (!timezone || !time) {
      return this.format(dateTime, !!time);
    }

    const dateTimeWithLocalUTC = moment.tz(dateTime, timezone).local();
    return this.format(dateTimeWithLocalUTC, true);
  }

  format(dateTime: string | Moment, hasTime: boolean): string {
    const formatRule = hasTime ? 'DD/MM/yyyy HH:mm' : 'DD/MM/yyyy';
    return moment(dateTime).format(formatRule);
  }
}
